<div class="flex justify-center px-4">
  <div class="container mx-auto">
    <div class="flex flex-col lg:flex-row md:mt-32 mt-24 gap-8">
      <app-order-info
        (filterChange)="onFilterSelected($event)"
        class="hidden md:block lg:w-1/4"
      ></app-order-info>
      <main class="lg:w-3/4">
        <h1 class="text-3xl font-extrabold mb-8 text-gray-900">Your Orders</h1>

        <app-order-info
          (filterChange)="onFilterSelected($event)"
          class="md:hidden block mb-5"
        ></app-order-info>
        <!-- List of orders -->
        @if (orders$ | async; as orders) {
          @if (orders.length === 0) {
            <div class="col-span-full flex justify-center">
              <app-items-not-found
                title="Orders not found!"
                description="We couldn’t find any orders here."
                [icon]="faBoxOpen"
              ></app-items-not-found>
            </div>
          }
          @for (order of orders; track order.id) {
            <app-order-item [order]="order"  (orderCancelled)="onOrderCancelled()"></app-order-item>
          }
        } @else {
          <div class="col-span-full flex justify-center">
            <app-items-loading />
          </div>
        }

        <div
          class="flex flex-col items-center mt-12 w-full"
          *ngIf="paginationInfo$ | async as pagination"
        >
          <div
            class="flex flex-col sm:flex-row sm:items-center w-full sm:w-auto px-3 py-3 rounded-lg gap-2 sm:gap-4"
          >
            <button
              class="px-3 sm:px-4 py-2 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="pagination.currentPage === 1"
              (click)="onPrevious($event)"
            >
              &laquo; <span class="sm:inline">Previous</span>
            </button>

            <div
              class="flex flex-wrap justify-center sm:justify-center flex-1 mx-0 sm:mx-2 space-x-1"
            >
              @for (
                page of getPageNumbers(
                  pagination.currentPage,
                  pagination.pageCount
                );
                track page
              ) {
                <button
                  class="w-8 h-8 text-xs font-medium rounded-lg transition-colors duration-150 border"
                  [class.text-white]="page === pagination.currentPage"
                  [class.bg-[#DC9D2A]]="page === pagination.currentPage"
                  [class.text-[#DC9D2A]]="page !== pagination.currentPage"
                  [class.bg-white]="page !== pagination.currentPage"
                  [class.border-gray-300]="page !== pagination.currentPage"
                  [class.hover\:bg-gray-100]="page !== pagination.currentPage"
                >
                  {{ page }}
                </button>
              }
            </div>

            <button
              class="px-3 sm:px-4 py-2 text-xs font-medium text-gray-700 bg-white border border-gray-300 rounded-lg hover:bg-gray-50 disabled:opacity-50 disabled:cursor-not-allowed"
              [disabled]="
                pagination.currentPage === pagination.pageCount ||
                pagination.pageCount == 0
              "
              (click)="onNext($event)"
            >
              <span class="sm:inline">Next</span> &raquo;
            </button>
          </div>

          <div class="mt-3 text-xs text-gray-600 text-center">
            Showing {{ pagination.from }} to {{ pagination.to }} of
            {{ pagination.totalCount }} items
          </div>
        </div>
      </main>
    </div>
  </div>
</div>
